textVerify = {
    data: {
        validated: 0,
        smsSent: null,
        type: null,
        number: null,
        lead_id: null,
        enteredCode: null,
    },

    textWatcher: function(propertyName, oldValue, newValue) {
        if(propertyName == 'lead_id' && textVerify.data.type == 'mobile') {

            textVerify.sendSms();
            return true;
        } else if(propertyName == 'lead_id' && data.type != 'mobile') {
        }

        if(propertyName == 'smsSent' && newValue == 1) {
            return true;
        }

        if(propertyName == 'validated' && newValue == 1) {
            formFunctions.getAutoQuote();
            return true;
        }

        if(propertyName == "wrong code") {

        }
    },

    modalTypeMobile: function() {
        formFunctions.loaderOff();
        $('#validate-mobile').modal({
            backdrop: 'static',
            keyboard: 'false'
        });
    },
    modalTypeMobileValidated: function() {
        formFunctions.loaderOff();
        $('#validate-mobile').hide();
        $('#validate-mobile-success').modal({
            backdrop: 'static',
            keyboard: 'false'
        });

    },

    sendSms: function () {

        var url = "sms-send/" + this.data.lead_id + "/" + this.data.number;

        jqxhr = $.get(url, function (data) {
        })
            .done(function (response) {
                textVerify.data.key = response.key;
                textVerify.data.smsSent = 1;
            })
            .fail(function () {

            })
            .always(function () {

            });
    },

    verifySmsCode: function ($code) {

        var url = "/sms-verify/" + $code;

        $.post( url, { 'leadId': textVerify.data.lead_id, 'key': textVerify.data.key })
            .done(function( data ) {
                textVerify.data.validated = data.status;

                if(data.status) {
                    textVerify.modalTypeMobileValidated();
                }

            })
            .fail(function () {

            })
            .always(function () {

            });
    },

    validateNewPhone: function(number) {
        if (number.length >= 10) {

            $('#progressBar_user_phone').show();
            $.ajax({
                type: "GET",
                url: "https://api2.irelocation.com/api/v1/validation/phone" + "/" + number + "+",
                dataType: "json",
                crossDomain: true,
                success: function (response, status, text) {
                    $('#progressBar_user_phone').hide();
                    if (response.status == 'success') {
                        if (response.type != 'mobile') {
                            window.location('http://www.callautoshippers.com');
                        } else {
                            textVerify.data.type = response.type;
                            textVerify.data.number = phoneNew.getVal();
                            textVerify.modalTypeMobile();
                            textVerify.sendSms();
                        }
                    } else {

                    }
                },
                error: function (request, status_text, error) {

                }
            }).done();
        }
    }

};